import { panelRangeSharedProps as o } from "./index935.js";
import { buildProps as n } from "./index601.js";
const r = n({
  ...o
}), a = [
  "pick",
  "set-picker-option",
  "calendar-change"
];
export {
  a as panelMonthRangeEmits,
  r as panelMonthRangeProps
};
